import { AfterViewInit, Directive } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { Observable, Subscription } from 'rxjs';
import { DEFAULT_PAGE_SIZE_OPTIONS } from '../../../constants/table-config';
import { ListClientPaginationStateModel, ListObject, ListServerPaginationStateModel } from '../../../models';
import { delay, filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

export type AvailableListDtoTypes<BriefType> =
  | ListClientPaginationStateModel<BriefType>
  | ListServerPaginationStateModel<BriefType>
  | ListObject<BriefType>;

@Directive()
export abstract class List<BriefType> implements AfterViewInit {
  abstract displayedColumns: string[];
  abstract listDto$: Observable<AvailableListDtoTypes<BriefType>>;
  abstract paginator: MatPaginator;
  dataSource: MatTableDataSource<BriefType>;
  selection: SelectionModel<BriefType> = new SelectionModel<BriefType>(false, []);
  subscriptions: Subscription[] = [];
  sortingMethod = (listItems: BriefType[]): BriefType[] => listItems;

  protected constructor(private translateService: TranslateService) {}

  ngAfterViewInit(): void {
    this.watchDataChanges();
  }

  protected initPaginator({ size, pageNumber, totalElements }: ListServerPaginationStateModel<BriefType>): void {
    this.paginator.pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS;
    this.paginator.pageSize = size;
    this.paginator.pageIndex = pageNumber;
    this.paginator.length = totalElements;
  }

  protected updateTable(tableDto: ListServerPaginationStateModel<BriefType>): void {
    this.dataSource = new MatTableDataSource(this.sortingMethod(tableDto.items.slice()));
    this.initPaginator(tableDto);
  }

  private watchDataChanges(): void {
    this.subscriptions.push(
      this.listDto$.pipe(delay(0), filter(Boolean)).subscribe((tableDto: ListServerPaginationStateModel<BriefType>) => {
        this.updateTable(tableDto);
      }),
      this.translateService.onLangChange.subscribe(() => {
        this.paginator.pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS;
      }),
    );
  }
}
